import {
    EMPLOYEE_PROVIDENTFUNDS_FETCHING,
    EMPLOYEE_PROVIDENTFUNDS_SUCCESS,
    EMPLOYEE_PROVIDENTFUNDS_FAILED,
  } from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case EMPLOYEE_PROVIDENTFUNDS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case EMPLOYEE_PROVIDENTFUNDS_FAILED:
        return { ...state, result: null, isFetching: false, isError: false };
      case EMPLOYEE_PROVIDENTFUNDS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }
  